import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-995a38c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collections" }
const _hoisted_2 = { class: "recipes" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Neueste Rezepte", -1))

import CollectionPanel from '../components/CollectionPanel.vue';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import RecipeListView from './RecipeListView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const store = useStore()

const collections = computed(() => store.getters.getCollections)
const maxCollections = ref(2)

onMounted(() => {
  setMediaQuery()
  window.addEventListener('resize', setMediaQuery);
})

function setMediaQuery() {
  if (window.matchMedia("(max-width: 1100px)").matches) { // If media query matches
      maxCollections.value = 1;
  } else {
      maxCollections.value = 2;
  }
}

onUnmounted(() => {
  window.removeEventListener('resize', setMediaQuery);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collections).slice(0, maxCollections.value), (item) => {
        return (_openBlock(), _createBlock(CollectionPanel, {
          key: item.title,
          collection: item
        }, null, 8, ["collection"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(RecipeListView)
    ])
  ], 64))
}
}

})